import { trackerApi } from '@/tracker/api/trackerApi';
import { SEARCH_PAGE_SIZE } from '@/tracker/hooks/useServerSearch';
import { User } from '@/tracker/types';

/**
 * Активные пользователи для выборов — подсказки сервера по ФИО, логину и email («Дима» найдёт
 * Дмитрия). С внешними: их назначают исполнителями и им выдают доступ к очередям. Ошибка — пусто
 */
export const searchActiveUsers = async (query: string): Promise<User[]> => {
  try {
    return await trackerApi.suggestUsers({
      query: query.trim() || undefined,
      includeExternal: true,
      pageSize: SEARCH_PAGE_SIZE,
    });
  } catch {
    return [];
  }
};
